<template>
    <div>
        <div>
            <div class="card p-2">
                <div class="text-center p-4 mb-4 bg-dark">
                    <span class="h1 font-weight-bold">
                        <i class="fa-solid fa-list-check mr-3"></i>
                        ALISTAMIENTO
                    </span>
                    <p class="mt-2">Registrar un nuevo alistamiento preventivo para la Super Transporte.</p>
                </div>
                <div class="bg-dark p-2">
                    <PasoAPaso numero="1" descripcion="Paso 1, Adjuntar archivos (opcional)" class="w-100 mt-4">
                        <div class="p-4">
                            <h4 class="py-2 border-collapse font-weight-bold">Subir archivo</h4>
                            <DropFileBasic ref="DropFileBasic" @handleFileData="handleFileUpload"
                                @change="handleFileUpload" :fileTypes="['application/pdf']" />
                        </div>
                    </PasoAPaso>
                    <form @submit.prevent="guardarAlistamiento()">
                        <PasoAPaso numero="2" descripcion="Paso 2, Suministrar información mantenimiento"
                            class="w-100 mt-4">
                            <div class="row  align-items-start p-4">
                                <!-- Tipo de Identificación -->
                                <div class="col-xl-6 mb-3">
                                    <label for="tipoIdentificacionResponsable" class="form-label">Tipo de
                                        Identificación Responsable</label>
                                    <select v-model="formData.tipoIdentificacionResponsable"
                                        id="tipoIdentificacionResponsable" class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoIdentificaciones" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>
                                <!-- Número de Identificación -->
                                <div class="col-xl-6 mb-3">
                                    <label for="formData.numeroIdentificacionResponsable" class="form-label">Número de
                                        Identificación Responsable</label>
                                    <input v-model="formData.numeroIdentificacionResponsable" type="number"
                                        id="numeroIdentificacionResponsable" class="form-control" required />
                                </div>

                                <!-- Nombres del Responsable -->
                                <div class="col-xl-12 mb-3">
                                    <label for="formData.nombreResponsable" class="form-label">Nombres del
                                        Responsable</label>
                                    <input v-model="formData.nombreResponsable" type="text" id="nombreResponsable"
                                        class="form-control" required />
                                </div>

                                <!-- Tipo de Identificación CONDUCTOR  -->
                                <div class="col-xl-6 mb-3">
                                    <label for="tipoIdentificacionConductor" class="form-label">Tipo de
                                        Identificación Conductor</label>
                                    <select v-model="formData.tipoIdentificacionConductor"
                                        id="tipoIdentificacionConductor" class="form-control" required>
                                        <option disabled value="">Seleccione una opción</option>
                                        <option v-for="tipo in tipoIdentificaciones" :key="tipo.codigo"
                                            :value="tipo.codigo">
                                            {{ tipo.descripcion }}
                                        </option>
                                    </select>
                                </div>
                                <!-- Número de Identificación CONDUCTOR -->
                                <div class="col-xl-6 mb-3">
                                    <label for="formData.numeroIdentificacionConductor" class="form-label">Número de
                                        Identificación Conductor</label>
                                    <input v-model="formData.numeroIdentificacionConductor" type="number"
                                        id="numeroIdentificacionConductor" class="form-control" required />
                                </div>

                                <!-- Nombres del Responsable CONDUCTOR -->
                                <div class="col-xl-12 mb-3">
                                    <label for="formData.nombresConductor" class="form-label">Nombres del
                                        Conductor</label>
                                    <input v-model="formData.nombresConductor" type="text" id="nombresConductor"
                                        class="form-control" required />
                                </div>

                                <!-- Detalle de Actividades -->
                                <div class="col-xl-12 mb-3">
                                    <label for="formData.detalleActividades" class="form-label">Detalle de
                                        Actividades</label>
                                    <b-form-textarea v-model="formData.detalleActividades" id="detalleActividades"
                                        placeholder="Describe las actividades realizadas en el mantenimiento" rows="3"
                                        minlength="10" maxlength="550" required />
                                </div>

                                <!-- Listado de Actividades -->
                                <div class="col-xl-12 mb-3">
                                    <label for="actividadesSeleccionadas" class="form-label">Detalle de
                                        Actividades</label>
                                    <MultiSelectReactivo v-model="actividadesSeleccionadas"
                                        :options="tipoListadoActividades" valorGuardar="id" valorVer=nombre
                                        emptyList="¡Lo sentimos!. No hemos cargado los detalles." :selectFirst="false"
                                        :allData="false" />
                                </div>
                            </div>
                        </PasoAPaso>
                        <!-- Botón Guardar -->
                        <div class="d-flex justify-content-end">
                            <vs-button type="submit" animation-type="vertical">
                                Guardar Registro
                                <template #animate>
                                    <i class="fas fa-plus-circle"></i>
                                </template>
                            </vs-button>
                        </div>
                    </form>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import Swal from "sweetalert2"
import { mapGetters } from 'vuex'
import DropFileBasic from "@/components/helexium/DropFileBasic.vue";
import PasoAPaso from './PasoAPaso.vue';
import MultiSelectReactivo from "../../../../../components/MultiSelect/MultiSelect.vue";

export default {
    components: {
        DropFileBasic,
        PasoAPaso,
        MultiSelectReactivo
    },
    props: {
        infoComplementaria: {
            type: Object,
            required: true
        },
        idMantenimiento: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            tipoIdentificaciones: [],
            tipoListadoActividades: [],

            actividadesSeleccionadas: [],
        }
    },
    computed: {
        ...mapGetters(['useMoment']),

        formData() {
            return {
                placa: this.infoComplementaria.placa,
                tipoIdentificacionResponsable: null,
                numeroIdentificacionResponsable: null,
                nombreResponsable: null,
                tipoIdentificacionConductor: null,
                numeroIdentificacionConductor: null,
                nombresConductor: null,
                mantenimientoId: this.idMantenimiento,
                detalleActividades: null,
            };
        }


    },
    async mounted() {
        await this.obtenerTiposIdentificacion();
        await this.obtenerListadoActividades();
    },
    methods: {

        async handleFileUpload(file) {
            if (!file) return;

            if (file.type !== 'application/pdf') {
                this.mostrarNotificacion('error', 'Archivo inválido', 'Solo se permiten archivos PDF.');
                return;
            }

            const archivo = file;
            const resultadoSubirArchivo = await this.$store.dispatch('hl_post_file_cookie', {
                path: `ApiSuperTransporteMantenimientos/subir-archivo?idVigilado=${this.infoComplementaria.vigiladoId}&tipoMantenimiento=${this.infoComplementaria.tipoId}&soloSubir=true`,
                data: archivo
            })

            if (resultadoSubirArchivo) {
                this.$vs.notification({
                    progress: "auto",
                    icon: `<i class='fas fa-exclamation-circle'></i>`,
                    color: "success",
                    position: "top-right",
                    title: "Éxito",
                    text: "El archivo ha sido cargado en la Super Transporte Exitosamente",
                });
            }

        },

        async obtenerTiposIdentificacion() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de identificación
                const response = await this.$store.dispatch("hl_get_cookie", {
                    path: "ApiSuperTransporteGenerales/listar-tipo-identificaciones",
                });

                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoIdentificaciones = response.filter(item => item.estado === true);
                    //console.log("Tipos de identificación filtrados:", this.tipoIdentificaciones);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener tipos de identificación:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },




        async guardarAlistamiento() {
            if (!this.infoComplementaria || !this.infoComplementaria.placa) {
                Swal.fire('Error', 'No se ha especificado la placa del vehículo', 'error');
                return;
            }



            try {
                this.isLoading = true;

                // Preparar los datos para el registro
                let datosRegistro = {
                    ...this.formData,
                    actividades: this.actividadesSeleccionadas
                };
                console.log("Enviando datos:", datosRegistro);
                this.$emit('consultarMantenimientos')
                // Registrar el mantenimiento/autorización
                const resultado = await this.$store.dispatch('hl_post_cookie', {
                    path: 'ApiSuperTransporteMantenimientos/registrar-alistamiento',
                    data: datosRegistro
                })

                console.log("Respuesta del servidor:", resultado);


                Swal.fire({
                    icon: "success",
                    title: "Registro exitoso",
                    text: `Se ha registrado el mantenimiento alistamiento`,
                    confirmButtonText: "Aceptar",
                });
            } catch (error) {
                console.error("Error al registrar:", error);
                this.errorMessage = error.message || "Error desconocido";
                this.registrationStatus = 'error';

                Swal.fire({
                    icon: 'error',
                    title: 'Error al registrar',
                    text: this.errorMessage,
                    confirmButtonText: 'Aceptar'
                });
            } finally {
                this.isLoading = false;
            }
        },


        async obtenerListadoActividades() {
            try {
                // Mostrar indicador de carga
                this.isLoading = true;

                // Llamar al servicio para obtener los tipos de identificación
                const response = await this.$store.dispatch('hl_get_cookie', {
                    path: 'ApiSuperTransporteMantenimientos/listar-actividades',
                })

                if (Array.isArray(response)) {
                    // Filtrar solo los tipos activos
                    this.tipoListadoActividades = response;
                    console.log("Tipos de identificación filtrados:", this.tipoListadoActividades);
                } else {
                    console.warn("El formato de la respuesta no es un array:", response);
                    this.$vs.notification({
                        color: "warning",
                        title: "Advertencia",
                        text: "El formato de los datos recibidos no es el esperado"
                    });
                }
            } catch (error) {
                console.error("Error al obtener listado de actividades:", error);
                this.$vs.notification({
                    color: "danger",
                    title: "Error de conexión",
                    text: "Hubo un problema al conectar con el servidor"
                });
            } finally {
                // Ocultar indicador de carga
                this.isLoading = false;
            }
        },
    }
}
</script>

<style scoped>
.image-link img {
    max-width: 100px;
    max-height: 100px;
}

.border-collapse {
    border-bottom: .5px solid #dee2e6;
}
</style>